export function _window(): Window & typeof globalThis {
  return window;
}
